import * as TimeOffSettingsIcons from './TimeOffsSettingsIcons'

export const TimeOffsSettingsIconsMap = {
  vacation: TimeOffSettingsIcons.TreePalmIcon,
  sickDay: TimeOffSettingsIcons.EcgHeartIcon,
  sickLeave: TimeOffSettingsIcons.HeartIcon,
  remote: TimeOffSettingsIcons.HomeIcon,
  unpaidVacation: TimeOffSettingsIcons.TravelLuggageIcon,
  unpaidSickDay: TimeOffSettingsIcons.HomeHeartFilledIcon,
  vacation2: TimeOffSettingsIcons.AirplanemodeActiveIcon,
  vacation3: TimeOffSettingsIcons.AirportShuttleIcon,
  sickLeave2: TimeOffSettingsIcons.FavoriteIcon,
  sickDay2: TimeOffSettingsIcons.AirlineSeatIndividualSuiteIcon,
  sickLeave3: TimeOffSettingsIcons.EnhancedEncryptionIcon,
  sickLeave4: TimeOffSettingsIcons.AddAlertIcon,
  sickLeave5: TimeOffSettingsIcons.HealthAndSafetyIcon,
  sickLeave6: TimeOffSettingsIcons.EventSeatIcon,
  unpaidSickDay2: TimeOffSettingsIcons.ReportProblemIcon,
  remote2: TimeOffSettingsIcons.EventIcon,
  remote3: TimeOffSettingsIcons.AccountBalanceWalletIcon,
  remote4: TimeOffSettingsIcons.AccountBalanceIcon,
  remote5: TimeOffSettingsIcons.BatteryChargingFullIcon,
  remote6: TimeOffSettingsIcons.BusinessCenterIcon,
  unpaidSickDay3: TimeOffSettingsIcons.AccountCircleIcon,
  unpaidSickDay4: TimeOffSettingsIcons.PermContactCalendarIcon,
  unpaidSickDay5: TimeOffSettingsIcons.SupervisorAccountIcon,
  unpaidVacation2: TimeOffSettingsIcons.MonetizationIcon,
  unpaidVacation3: TimeOffSettingsIcons.PaymentIcon
}
